mutation TravelAuthorizationUploadDocument(
  $document: DocumentUploadInput!
  $travelAuthorizationId: UUID!
) {
  travelAuthorizationUploadDocument(
    document: $document
    travelAuthorizationId: $travelAuthorizationId
  ) {
    uploadLink
    document {
      _documentFileId
      travelAuthorizationDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
